module.exports = __webpack_public_path__ + "static/media/stretching.f8d37e2e.jpg";